import { useTranslation } from 'react-i18next';
import { BaseButton, ButtonState } from 'components/Shared/Buttons';
import { fonts } from 'components/styles/variables';

interface SaveSearchButtonProps {
  isSearchSaved: boolean;
  onClick?: () => void;
}

export default function SaveSearchButton({
  isSearchSaved,
  onClick,
}: SaveSearchButtonProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseButton
      aria-label="save-search-button"
      normalText={t('srp.filters.saveSearch')}
      disabledText={t('srp.filters.searchSaved')}
      state={isSearchSaved ? ButtonState.disabled : ButtonState.normal}
      onClick={onClick}
      className="save-search-button"
      style={{
        fontFamily: fonts.default,
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.2px',
        textTransform: 'none',
        borderRadius: '4px',
        height: '32px',
      }}
    />
  );
}
